import sharedEn from '@/lang/shared/en.json'
import sharedEt from '@/lang/shared/et.json'
import en from './en.json'
import et from './et.json'

export const kihnuTranslations = {
  en: { ...sharedEn, ...en },
  et: { ...sharedEt, ...et },
}
